// Libarary
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import pdfMake from 'pdfmake/build/pdfmake';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';

// View Model
import { AccountVM } from '../../models/AccountMasterVM';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { BroadcastService } from '../infrastructure/broadcaster.service';
import { NetworkService } from '../infrastructure/network.service';
import { MasterConstants } from '../../common/constants/master-constants';
import { LoaderService } from '../infrastructure/loader.service';
import { CPPOrderSummaryVM } from '../../models/CPP/CPPOrderSummaryVM';
import { CommonService } from './../common/common.service';

@Injectable()
export class CppCoiRequestService {
  public SelectedAccountObj: BehaviorSubject<AccountVM>;
  public selectedAccountNo: any;
  public selectedAccountParentNo: any;
  public isEditMode = false;
  public productList: any = [];
  public redirectFrom: any;
  public returnRequestStatus: string;
  orderPdf: CPPOrderSummaryVM = new CPPOrderSummaryVM();
  pdfDataObject: any;
  totalNumbersOfOrder = 0;
  totalnumbersOfProduct = 0;
  totalOrderCost = 0;
  deliverToAccountdetails: any = {};
  soldToAccountdetails: any = {};
  basePdfData: string;

  constructor(public broadcastService: BroadcastService,
    public configService: ConfigService,
    public loaderService: LoaderService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private networkService: NetworkService) {
    this.SelectedAccountObj = new BehaviorSubject<AccountVM>(null);
    this.returnRequestCppId = new BehaviorSubject(0);
    this.OrderId = new BehaviorSubject(0);
  }
  webOrderNumberAndSplitId: any;
  returnRequestCppId: BehaviorSubject<number>;
  OrderId: BehaviorSubject<number>;
  coiOrderNumber: any;

  public setCppReturnRequestId(value: number) {
    this.returnRequestCppId.next(value);
  }
  public setReturnRequestStatus(value: string) {
    this.returnRequestStatus = value;
  }
  public setRedirectionFrom(value) {
    this.redirectFrom = value;
  }

  public setCoiOrderIdCPP(value: number) {
    this.OrderId.next(value);
  }
  getSelectedAccountNo() {
    return this.selectedAccountNo;
  }

  setSelectedAccountNo(selectedAccountNo) {
    this.selectedAccountNo = selectedAccountNo;
  }

  getSelectedParentAccountNo() {
    return this.selectedAccountParentNo;
  }

  setSelectedParentAccountNo(selectedAccountParentNo) {
    this.selectedAccountParentNo = selectedAccountParentNo;
  }

  getEditModeStatus() {
    return this.isEditMode;
  }

  setEditModeStatus(isEditMode) {
    this.isEditMode = isEditMode;
  }
  getProductList() {
    return this.productList;
  }

  setProductList(productList) {
    this.productList = productList;
  }
  public AccountChange(obj: AccountVM) {
    this.SelectedAccountObj.next(obj);
  }

  // Get product list
  // public getProductMaster(companyCode, accountNumber) {
  //  return this.networkService.getRequest(this.configService.getCoiProductItemsData() + '?companyCode=' + companyCode + '&accountNumber=' + accountNumber);
  // }
  public getProductMaster(filters) {
    return this.networkService.postRequest(this.configService.getCoiProductItemsData(), filters);
  }

  // Get Landing Grid Data
  public getLandingGridData(filters) {
    return this.networkService.postRequest(this.configService.getCoiLandingGridDataUrl, filters);
  }

  // Get Landing Export Data
  public getLandingExportData(filters) {
    return this.networkService.postRequest(this.configService.getCoiLandingExportDataUrl, filters);
  }

  // Get landing banner message
  public getLandingBannerMessage() {
    return this.networkService.getRequest(this.configService.getCoiLandingBannerMessageUrl);
  }

  // Check for existing Draft Order
  public checkExistingCOIDraftOrder(accountNumber) {
    return this.networkService.getRequest(this.configService.checkExistingCOIDraftOrder() + '?accountNumber=' + accountNumber);
  }

  // Get Coi Deliver
  public getCoiDeliverTo(accountNumber, shipToAccountParentNumber) {
    return this.networkService.getRequest(this.configService.getCoiDeliverToFacilityData() + '?accountNumber=' + accountNumber + '&shipToAccountParentNumber=' + shipToAccountParentNumber);
  }

  // Get Coi Sold To
  public getCoiSoldTo(accountNumber) {
    return this.networkService.getRequest(this.configService.getCoiSoldToFacilityData() + '?accountNumber=' + accountNumber);
  }

  // Get Cpp Ship To Facility List
  public getCoiShipToAccountDataList() {
    return this.networkService.getRequest(this.configService.getCoiShipToAccountData());
  }

  // Get coi Instruction type list
  public getcoiInstructionTypeList() {
    return this.networkService.getRequest(this.configService.getCoiInstructionTypeData());
  }

  // Get coi Instruction type list
  public getCoiItemNumbersData() {
    return this.networkService.getRequest(this.configService.getCoiItemNumbersData());
  }

  // Get Coi Edit order detail
  public getCppCoiEditOrderDetail(orderId) {
    return this.networkService.getRequest(this.configService.getCoiEditOrderDetailData() + '?orderId=' + orderId);
  }

  // send COI new request Email
  public sendCoiNewRequestEmail(emailObject) {
    return this.networkService.postRequest(this.configService.sendCoiNewRequestEmail(), emailObject);
  }

  // send COI new request Email
  public deleteDraftRequest(requestId) {
    return this.networkService.postRequest(this.configService.deleteDraftRequestDetail(), requestId);
  }

  // Save Create Order
  public saveCoiOrder(saveObj) {
    return this.networkService.postRequest(this.configService.saveCoiOrder(), saveObj);
  }

  // Place Order
  public placeCoiOrder(saveObj) {
    return this.networkService.postRequest(this.configService.placeCoiOrder(), saveObj);
  }

  // Get Order Summary data
  public getOrderSummaryDetails(coiOrderNumber) {
    return this.networkService.getRequest(this.configService.getCOIOrderSummaryDetailsUrl + '?coiOrderNumber=' + coiOrderNumber);
  }

  // pdf from base64 date
  public sendBaseDate(filters) {
    return this.networkService.postRequest(this.configService.postFileForPdf(), filters);
  }

  // Get account SDM
  public getAccountSDMData(accountNumber) {
    return this.networkService.getRequest(this.configService.getCoiAccountSDMData() + '?accountNumber=' + accountNumber);
  }

  // Get items SDM
  public getItemsSDM(itemIds: string, accountNumber: number, isCustomerPickup) {
    return this.networkService.getRequest(this.configService.getCoiItemsSDM() + '?itemIds=' + itemIds + '&accountNumber='
      + accountNumber + '&isCustomerPickup=' + isCustomerPickup);
  }

  // Get Delivery Date Reason Change dropdown list
  public getDeliveryDateReasonList() {
    return this.networkService.getRequest(this.configService.getCoiDeliveryChangeReasonDate());
  }

  // check OTI Orders Exist for Customer PO
  public checkOTIOrders(shipToAccount, customerPO) {
    return this.networkService.getRequest(this.configService.coiCPPCheckOTIOrdersUrl + '?shipToAccount=' + shipToAccount + '&customerPO=' + customerPO);
  }

  public generatePdf(coiOrderNumber) {
    if (coiOrderNumber) {
      this.loaderService.setLoaderStatus(true);
      const self = this;
      this.getOrderSummaryDetails(coiOrderNumber).subscribe((result: CPPOrderSummaryVM) => {
        if (result) {
          if (result !== undefined && result.splitDetails.length > 0) {
            self.orderPdf = result;
            this.pdfDataObject = result;
            this.totalNumbersOfOrder = result.splitDetails.length;
            result.splitDetails.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
            const documentDefinition = this.getDocumentDefinition();
            pdfMake.createPdf(documentDefinition).download('COI_' + coiOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
          } else {
            this.toastrService.error('No data available for WebOrderNumber #' + coiOrderNumber);
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      });
    }
  }

  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MMMM dd, yyyy');
    const orderCreateDate = this.pdfDataObject.createdOnString;
    this.deliverToAccountdetails = {};
    this.soldToAccountdetails = {};

    if (this.pdfDataObject.deliverToDetail) {
      this.deliverToAccountdetails.AccountNumber = this.pdfDataObject.deliverToDetail.accountNo;
      this.deliverToAccountdetails.AccountName = this.pdfDataObject.deliverToDetail.accountName;
      this.deliverToAccountdetails.Address1 = this.pdfDataObject.deliverToDetail.address1;
      this.deliverToAccountdetails.Address2 = this.pdfDataObject.deliverToDetail.Address2;
      this.deliverToAccountdetails.AccountCity = this.pdfDataObject.deliverToDetail.city;
      this.deliverToAccountdetails.AccountState = this.pdfDataObject.deliverToDetail.state;
      this.deliverToAccountdetails.AccountZipCode = this.pdfDataObject.deliverToDetail.zipCode;
    }

    // this.soldToAccountdetails
    if (this.pdfDataObject.soldToDetail) {
      this.soldToAccountdetails.AccountNumber = this.pdfDataObject.soldToDetail.accountNo;
      this.soldToAccountdetails.AccountName = this.pdfDataObject.soldToDetail.accountName;
      this.soldToAccountdetails.Address1 = this.pdfDataObject.soldToDetail.address1;
      this.soldToAccountdetails.Address2 = this.pdfDataObject.soldToDetail.address2.replace('<br>', '');
      this.soldToAccountdetails.AccountCity = this.pdfDataObject.soldToDetail.city;
      this.soldToAccountdetails.AccountState = this.pdfDataObject.soldToDetail.state;
      this.soldToAccountdetails.AccountZipCode = this.pdfDataObject.soldToDetail.zipCode;
    }

    let displayWith = [];
    let columnList = [];
    let valueList = [];

    // ShipTo Account available
    if (!this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['100%'];
      columnList = [{ text: 'SHIP TO: ', bold: true }];
      valueList = [
        this.pdfDataObject.accountNumber + ' \n' +
        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode + ' \n' +
        'Order #: ' + this.pdfDataObject.webOrderNumber.toString() + '\n' +
        'Customer PO#: ' + this.pdfDataObject.custPONumber
      ];
    }
    // ShipTo & DeliverTo  Account available
    else if (this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SHIP TO: ', bold: true }, { text: 'DELIVER TO: ', bold: true }];
      valueList = [
        this.pdfDataObject.accountNumber + ' \n' +
        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode + ' \n',

        this.deliverToAccountdetails.accountNumber + ' \n' +
        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        (this.deliverToAccountdetails.Address2 == '' || this.deliverToAccountdetails.Address2 == undefined ? '' : this.deliverToAccountdetails.Address2 + ' \n') +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n' +
        'Order #: ' + this.pdfDataObject.webOrderNumber.toString() + '\n' +
        'Customer PO#: ' + this.pdfDataObject.custPONumber
      ];
    }
    // ShipTo & SoldTo Account available
    else if (!this.deliverToAccountdetails.AccountName && this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SOLD TO: ', bold: true }, { text: 'SHIP TO: ', bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountNumber + ' \n' +
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' || this.soldToAccountdetails.Address2 == undefined ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountNumber + ' \n' +
        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode + ' \n' +
        'Order #: ' + this.pdfDataObject.webOrderNumber.toString() + '\n' +
        'Customer PO#: ' + this.pdfDataObject.custPONumber,
      ];
    }
    // ShipTo, SoldTo & DeliverTo Account available
    else {
      displayWith = ['33%', '33%', '33%'];
      columnList = [{ text: 'SOLD TO: ', bold: true }, { text: 'SHIP TO: ', bold: true }, { text: 'DELIVER TO: ', bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountNumber + ' \n' +
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' || this.soldToAccountdetails.Address2 == undefined ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountNumber + ' \n' +
        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode + ' \n' +
        'Order #: ' + this.pdfDataObject.webOrderNumber.toString() + '\n' +
        'Customer PO#: ' + this.pdfDataObject.custPONumber,

        this.deliverToAccountdetails.AccountNumber + ' \n' +
        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        (this.deliverToAccountdetails.Address2 == '' || this.deliverToAccountdetails.Address2 == undefined ? '' : this.deliverToAccountdetails.Address2 + ' \n') +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',

      ];
    }

    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: currDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          style: 'pageText',
          widths: ['25%', '50%', '25%'],
          marginTop: 10,
          fontSize: 8,
          bold: true,
          columns: [{
            image: 'data:image/png;base64,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',
            width: 60,
            height: 20,
            alignment: 'left',
            fit: [100, 100]
          },
          // {
          //  text: currDate, alignment: 'right', fontSize: 8, style: 'pageText', marginRight: 30
          // },
          {
            text: currDate, alignment: 'right', fontSize: 15, style: 'pageText', marginRight: 30
          }]
        },
        {
          style: 'headername',
          table: {
            body: [
              [
                ('A new COI Request has been created!\n')
              ],
            ]
          },
          fontSize: 18,
          layout: 'noBorders',
          marginTop: 10
        },
        {
          layout: 'noBorders',
          table: {
            body: [
              ['\n Dear ' + this.pdfDataObject.placedByName + ',']
            ]
          },
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          text: [
            'A new request has been created for ',
            { text: this.soldToAccountdetails.AccountName, bold: true },
            '. Please review the request below to ensure accuracy.'
          ],
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          table: {
            body: [
              [{
                text: 'This is a request for shipment based on owned inventory.This request will not be invoiced.',
                borderColor: ['#ED4454', '#ED4454', '#ED4454', '#ED4454'],
                color: '#ED4454',
                fontSize: 8,
                bold: true,
              }
              ]
            ]
          },
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            fontSize: 5,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'tableHeader',
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 2 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 2 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#d7dcee' : '#F5F6FA';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#d7dcee' : '#d7dcee';
            },
          }
        },
        this.getContractPdfObject(this.pdfDataObject.splitDetails),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis order was committed by ' + this.pdfDataObject.placedByName + ' on ' + orderCreateDate
                + ' (CST). If you have any questions regarding these changes, please contact WinField United Customer Service, #855-494-6343.'],
            ]
          },
          layout: 'noBorders',
          marginTop: 20
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        headername: {
          fontSize: 18,
          bold: true,
          color: '#0b3f54'
        },
        tableHeader: {
          bold: true,
          fillColor: '#F5F6FA',
          fontSize: 8,
          color: '#0b3f54',
          border: [true, true, true, true],
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
      }
    };

    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(splitDetails) {
    const tblObject = [];
    splitDetails.forEach(obj => {
      let jdeNumber = '';
      if (obj.jdeorderNumber) {
        jdeNumber = obj.jdeorderNumber;
      }
      const requestDetails = obj.productDetail;
      const desDelDate = (obj.productDetail[0].desiredDeliveryDate == null || obj.productDetail[0].desiredDeliveryDate == undefined) ? '' : obj.productDetail[0].desiredDeliveryDate;
      const desiredDeliveryDate = (desDelDate === '' ? '' : this.datePipe.transform(desDelDate.toString(), 'MM/dd/yyyy'));
      if (jdeNumber != '') {
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '10%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Request: ' + this.pdfDataObject.webOrderNumber.toString() + '-' + obj.splitId.toString(),
              alignment: 'left',
            },
            // {
            //  text: 'Status: ' + obj.orderStatus.toString(),
            //  alignment: 'left',
            // },
            {
              text: 'Requested Arrival Date: ' + desiredDeliveryDate,
              alignment: 'right',
            }]
          }
        ];

        tblObject.push(tblHeader);
      }
      else {
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['25%', '25%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Request: ' + this.pdfDataObject.webOrderNumber.toString() + '-' + obj.splitId.toString(),
              alignment: 'left',
            },
            // {
            //  text: 'Status: ' + obj.orderStatus.toString(),
            //  alignment: 'left',
            // },
            {
              text: 'Requested Arrival Date: ' + desiredDeliveryDate,
              alignment: 'right',
            }]
          }
        ];

        tblObject.push(tblHeader);
      }

      const tbl = {
        layout: 'noBorders',
        table: {
          widths: ['45%', '10%', '10%', '10%', '25%'], // , '10%', '10%', '10%', '15%'
          color: '#0b3f54',
          body: [
            [{
              text: 'PRODUCT',
              style: 'tableHeader', marginTop: 5,
            },
            {
              text: 'Product Line',
              style: 'tableHeader', marginTop: 5,
            },
            {
              text: 'Quantity Requested',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Ordering UOM',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Package Size',
              style: 'tableHeader', alignment: 'center'
            },
            ],
            ...requestDetails.map(cpp => [
              { text: cpp.itemDescription },
              /* ((cpp.itemVendorName) ? (cpp.itemVendorName + " \n" + cpp.itemDescription) : '' + cpp.itemDescription),*/
              { text: cpp.productLine, alignment: 'center' },
              { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.orderedQuantity.toFixed(this.commonService.countDecimals(cpp.orderedQuantity)), alignment: 'center' },
              { text: cpp.orderUOM, alignment: 'center' },
              { text: cpp.packageSize, alignment: 'center' },
            ])
          ]
        },
        style: 'tablefont',
        marginTop: 5,
      };
      tblObject.push(tbl);
    });

    return tblObject;
  }
}
